import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    finishID: item.id,
    headingHeightInMm: ConvertCentimetersToMillimeters(item.headingHeight)
  };
  delete dto.id;
  delete dto.headingHeight;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.finishID,
    headingHeight: ConvertMillimetersToCentimeters(dto.headingHeightInMm)
  };
  delete item.finishID;
  delete item.headingHeightInMm;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
